'use client';
import Image from 'next/image';

const speakers = [
   {
    name: "Anish Mohammed",
    designation: "CTO",
    company: "CTOPanther Protocol",
    imageSrc: "/images/speakers/anish-mohammed.webp",
    alt: "anish-mohammed",
  },
  {
    name: "Viktoria	Soltesz",
    designation: "Founder",
    company: "PSP Angels",
    imageSrc: "/images/speakers/viktoria-soltesz-.webp",
    alt: "viktoria-soltesz",
  },
  {
    name: "Piyush Gupta",
    designation: "Core Contributor",
    company: "Integra",
    imageSrc: "/images/speakers/piyushgupta.webp",
    alt: "piyush-gupta",
  },
  {
    name: "Emilie Raffo" ,
    designation: "Founding partner & sales director",
    company: "ChainSecurity",
    imageSrc: "/images/speakers/emilie.webp",
    alt: "emilie-raffo",
  },
  // end od past speaker 2025
  {
    name: "Henry Mcphie",
    designation: "Co-Founder & CEO",
    company: "Streamex",
    imageSrc: "/images/speakers/henry.webp",
    alt: "Henry-Mcphie",
  },
  {
    name: "Kerching Choo",
    designation: "CTO",
    company: "HeLa Labs",
    imageSrc: "/images/speakers/kerching.webp",
    alt: "Kerching-Choo",
  },
  {
    name: "Aravind 	Sathyanandham",
    designation: "Head of Market Growth",
    company: "Mansa",
    imageSrc: "/images/speakers/aravind-sathyanandham.webp",
    alt: "Aravind",
  },
 {
    name: "Varun",
    designation: "Co-Founder & CEO",
    company: "Hibachi",
    imageSrc: "/images/speakers/varun.webp",
    alt: "varun",
  },
  {
    name: "Charlie Hu",
    designation: "Co-Founder",
    company: "Bitlayer",
    imageSrc: "/images/speakers/charlie.webp",
    alt: "Charlie",
  },
  {
    name: "Polina Morozova" ,
    designation: "Head of Operations",
    company: "Alba Ventures",
    imageSrc: "/images/speakers/polina-morozova-pic.webp",
    alt: "polina",
  },
  {
    name: "Malak Alba" ,
    designation: "CEO",
    company: "Alba Ventures",
    imageSrc: "/images/speakers/malak-moderator.webp",
    alt: "Malak Alba",
  },
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:87:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="87" data-component-end-line="129" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%20bg-gradient-to-br%20from-%5B%235b17b4%5D%20to-%5B%230a001f%5D%22%7D"
      id="speakers"
      className="w-full p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4 bg-gradient-to-br from-[#5b17b4] to-[#0a001f]"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:91:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="91" data-component-end-line="128" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
        {/* Section Title */}
       <h2 data-component-id="src/app/SpeakerSection.jsx:93:7" data-component-path="src/app/SpeakerSection.jsx" data-component-line="93" data-component-end-line="95" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B32px%5D%20sm%3Atext-%5B28px%5D%20md%3Atext-%5B48px%5D%20font-instrument%20font-medium%20leading-%5B35px%5D%20sm%3Aleading-%5B38px%5D%20md%3Aleading-%5B42px%5D%20text-center%20text-%5B%23fff%5D%20mb-10%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-[32px] sm:text-[28px] md:text-[48px] font-instrument font-medium leading-[35px] sm:leading-[38px] md:leading-[42px] text-center text-[#fff] mb-10">
        Past Speakers
      </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.jsx:97:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="97" data-component-end-line="127" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full  max-w-[1200px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.jsx:99:10" data-component-path="src/app/SpeakerSection.jsx" data-component-line="99" data-component-end-line="126" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-y-10%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-10 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.jsx:101:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="101" data-component-end-line="124" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakerSection.jsx:103:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="103" data-component-end-line="114" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B200px%5D%20sm%3Ah-%5B200px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px] relative mb-4">
                  <Image data-component-id="src/app/SpeakerSection.jsx:104:18" data-component-path="src/app/SpeakerSection.jsx" data-component-line="104" data-component-end-line="113" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%20w-50%20h-50%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    height={300}
                    width={300}
                    sizes="200px"
                    objectFit="cover"
                    className="rounded-full w-50 h-50"
                    unoptimized
                  />
                </div>
                <h3 data-component-id="src/app/SpeakerSection.jsx:115:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="115" data-component-end-line="117" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-white%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-white text-[13px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.jsx:118:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="118" data-component-end-line="120" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-white text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.jsx:121:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="121" data-component-end-line="123" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-white text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
